export default "__VITE_ASSET__paSVprOd__"